const initKeenzHome = () => {
  const root = document.querySelector('.keenz-shopify-home');
  if (!root || root.dataset.keenzReady === 'true') return;
  root.dataset.keenzReady = 'true';

  const menuButton = root.querySelector('.menu-button');
  const menu = root.querySelector('.nav-links');
  menuButton?.addEventListener('click', () => {
    const open = menu.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
  });
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    menu.classList.remove('open');
    menuButton?.setAttribute('aria-expanded', 'false');
  }));

  const serviceRows = [...root.querySelectorAll('[data-service-index]')];
  const serviceImages = [...root.querySelectorAll('[data-service-image]')];
  const serviceLabel = root.querySelector('.visual-label b');
  const activateService = (index) => {
    serviceRows.forEach((row, rowIndex) => row.classList.toggle('active', rowIndex === index));
    serviceImages.forEach((image, imageIndex) => image.classList.toggle('active', imageIndex === index));
    if (serviceLabel) serviceLabel.textContent = String(index + 1).padStart(2, '0');
  };
  serviceRows.forEach((row, index) => {
    row.addEventListener('mouseenter', () => activateService(index));
    row.addEventListener('focus', () => activateService(index));
  });
  if (window.matchMedia('(max-width: 900px)').matches && serviceRows.length) {
    const serviceScroller = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) activateService(serviceRows.indexOf(entry.target));
      });
    }, { rootMargin: '-34% 0px -46% 0px', threshold: 0 });
    serviceRows.forEach((row) => serviceScroller.observe(row));
  }

  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        reveal.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  root.querySelectorAll('[data-reveal]').forEach((element) => reveal.observe(element));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKeenzHome, { once: true });
} else {
  initKeenzHome();
}
document.addEventListener('shopify:section:load', initKeenzHome);

const initCatalogFilters = () => {
  const filters = document.querySelector('.catalog-filters');
  if (!filters || filters.dataset.ready === 'true') return;
  filters.dataset.ready = 'true';
  const buttons = [...filters.querySelectorAll('[data-catalog-filter]')];
  const cards = [...document.querySelectorAll('[data-catalog-tags]')];
  const count = document.querySelector('[data-catalog-count]');
  buttons.forEach((button) => button.addEventListener('click', () => {
    const filter = button.dataset.catalogFilter;
    let visible = 0;
    cards.forEach((card) => {
      const tags = (card.dataset.catalogTags || '').split('|');
      const title = card.dataset.catalogTitle || '';
      const badge = title.includes('badge') || title.includes('emblem')
        || tags.some((tag) => tag.includes('badge') || tag.includes('emblem'));
      const gauge = title.includes('gauge');
      const keyring = title.includes('keychain') || title.includes('keyring');
      const interior = gauge || ['console', 'cubby', 'cup holder', 'sun visor'].some((term) => title.includes(term));
      const exterior = badge || ['fuel cap', 'bov block', 'battery tie down', 'centre cap', 'center cap'].some((term) => title.includes(term));
      let show = filter === 'all'
        || tags.includes(filter)
        || (filter === 'gauges' && gauge)
        || (filter === 'keyrings' && keyring)
        || (filter === 'badges' && badge)
        || (filter === 'interior accessories' && interior)
        || (filter === 'exterior accessories' && exterior)
        || (filter === 'car accessories' && tags.includes('car accessory'));
      if (filter === 'interior accessories' && badge) show = false;
      card.hidden = !show;
      if (show) visible += 1;
    });
    buttons.forEach((item) => {
      const active = item === button;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    if (count) count.textContent = `${visible} ${visible === 1 ? 'PRODUCT' : 'PRODUCTS'}`;
  }));
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCatalogFilters, { once: true });
} else {
  initCatalogFilters();
}
document.addEventListener('shopify:section:load', initCatalogFilters);

const initProductGalleries = () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    if (gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';
    const mainImage = gallery.querySelector('[data-main-product-image]');
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-image]')];
    const currentLabel = gallery.querySelector('[data-gallery-current]');
    if (!mainImage || !thumbnails.length) return;
    let current = 0;

    const showImage = (index, source) => {
      current = (index + thumbnails.length) % thumbnails.length;
      const nextSource = source || thumbnails[current].dataset.galleryImage;
      mainImage.classList.add('is-updating');
      mainImage.src = nextSource;
      mainImage.onload = () => mainImage.classList.remove('is-updating');
      thumbnails.forEach((thumbnail, thumbnailIndex) => {
        const active = thumbnailIndex === current;
        thumbnail.classList.toggle('active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
    };

    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', () => showImage(index)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(current - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(current + 1));
    mainImage.addEventListener('keenz:image-change', (event) => {
      const source = event.detail?.src;
      const match = thumbnails.findIndex((thumbnail) => thumbnail.dataset.galleryImage?.split('?')[0] === source?.split('?')[0]);
      showImage(match >= 0 ? match : current, source);
    });
  });
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGalleries, { once: true });
} else {
  initProductGalleries();
}
document.addEventListener('shopify:section:load', initProductGalleries);

document.querySelectorAll('[data-keenz-product-form]').forEach((form) => {
  const variantData = form.querySelector('[data-product-variants]');
  if (!variantData) return;
  const variants = JSON.parse(variantData.textContent || '[]');
  const groups = [...form.querySelectorAll('[data-option-index]')];
  const idInput = form.querySelector('[data-variant-id]');
  const summary = form.querySelector('[data-selected-variant]');
  const submit = form.querySelector('[data-product-submit]');
  const customRequirements = form.querySelector('[data-custom-requirements]');
  const customRequirementsInput = form.querySelector('[data-custom-requirements-input]');
  const mainImage = document.querySelector('[data-main-product-image]');
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });

  const updateVariant = () => {
    const selected = groups.map((group) => group.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
    const customSelected = selected.some((value) => /custom/i.test(value || ''));
    if (customRequirements && customRequirementsInput) {
      customRequirements.hidden = !customSelected;
      customRequirementsInput.disabled = !customSelected;
      customRequirementsInput.required = customSelected;
      if (!customSelected) customRequirementsInput.value = '';
    }
    if (variant && idInput) idInput.value = variant.id;
    if (summary) summary.textContent = variant ? `${variant.title} · ${money.format(variant.price / 100)}` : 'Combination unavailable';
    const variantImage = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
    if (mainImage && variantImage) {
      const imageUrl = variantImage.startsWith('//') ? `https:${variantImage}` : variantImage;
      if (mainImage.src !== imageUrl) {
        if (mainImage.closest('[data-product-gallery]')?.querySelector('[data-gallery-image]')) {
          mainImage.dispatchEvent(new CustomEvent('keenz:image-change', { detail: { src: imageUrl } }));
        } else {
          mainImage.classList.add('is-updating');
          mainImage.src = imageUrl;
          mainImage.onload = () => mainImage.classList.remove('is-updating');
        }
      }
    }
    if (submit) {
      submit.disabled = !variant?.available;
      submit.childNodes[0].textContent = variant?.available ? 'Add to cart ' : 'Unavailable ';
    }
  };

  form.addEventListener('change', updateVariant);
  updateVariant();
});
